import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {requestWebhookDeliveryLogs} from "../../../redux/Actions/webhooks.actions";
import {
  getDeliveryLogs,
  getDeliveryLogsTotalCount,
  getDeliveryLogsPaginationUrls,
} from "../../../redux/Selectors/webhooks.selector";

export const useDeliveryLogsTableData = (webhookId) => {
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const deliveryLogs = useSelector(getDeliveryLogs);
  const totalCount = useSelector(getDeliveryLogsTotalCount);
  const deliveryLogUrls = useSelector(getDeliveryLogsPaginationUrls);

  useEffect(() => {
    dispatch(requestWebhookDeliveryLogs(webhookId));
  }, [dispatch, webhookId]);

  const handlePageChange = (page) => {
    const url = currentPage < page ? deliveryLogUrls?.nextUrl : deliveryLogUrls?.prevUrl;
    dispatch(requestWebhookDeliveryLogs(webhookId, url));
    setCurrentPage(page);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePageChange,
  };

  return {deliveryLogs, paginationConfig, totalCount};
};
